import type { IntlShape } from 'react-intl-next';
import { formatDistanceToNow } from 'date-fns';

import { i18n } from './quickReloadi18n';
import type { UserInfo } from './pubSubUtils';

export const getCommentFlagMessage = (
	eventsExcludingCurrentUserEvents: UserInfo[],
	numberOfUniqueCommenters: number,
	intl: IntlShape,
	commentType: string,
	commentCreatedDate?: string,
	documentNeedsUpdate?: boolean,
) => {
	const timeAgo = commentCreatedDate
		? formatDistanceToNow(new Date(commentCreatedDate), { addSuffix: true })
		: 'just now';

	switch (numberOfUniqueCommenters) {
		case 1:
			return intl.formatMessage(
				documentNeedsUpdate ? i18n.somebodyCommentedDifferentVersion : i18n.somebodyCommented,
				{
					somebody: eventsExcludingCurrentUserEvents[0].displayName,
					commentType,
					timeAgo,
				},
			);
		default:
			return intl.formatMessage(
				documentNeedsUpdate
					? i18n.multiplePeopleCommentedDifferentVersion
					: i18n.multiplePeopleCommented,
				{
					somebody:
						eventsExcludingCurrentUserEvents[eventsExcludingCurrentUserEvents.length - 1]
							?.displayName,
					numOthers: numberOfUniqueCommenters - 1,
					commentType,
					timeAgo,
				},
			);
	}
};
